var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "execution",
      class: {
        loading:
          _vm.wfLoading ||
          (_vm.history.loading &&
            (!_vm.historyEvents || !_vm.historyEvents.length)),
        ready: !_vm.wfLoading && !_vm.history.loading
      }
    },
    [
      _c(
        "navigation-bar",
        [
          _c("navigation-link", {
            attrs: {
              id: "nav-link-summary",
              icon: "icon_receipt",
              label: "Summary",
              to: {
                name: "workflow/summary",
                params: { clusterName: _vm.clusterName }
              },
              "data-cy": "summary-link"
            }
          }),
          _vm._v(" "),
          _c("navigation-link", {
            attrs: {
              id: "nav-link-history",
              icon: "icon_trip-history",
              label: "History",
              to: {
                name: "workflow/history",
                params: { clusterName: _vm.clusterName }
              },
              "data-cy": "history-link"
            }
          }),
          _vm._v(" "),
          _c("navigation-link", {
            attrs: {
              id: "nav-link-pending",
              icon: "icon_send",
              label: "Pending",
              "notification-count": _vm.pendingTaskCount,
              to: {
                name: "workflow/pending",
                params: { clusterName: _vm.clusterName }
              },
              "data-cy": "pending-link"
            }
          }),
          _vm._v(" "),
          _c("navigation-link", {
            attrs: {
              id: "nav-link-stack-trace",
              icon: "icon_trips",
              label: "Stack Trace",
              to: {
                name: "workflow/stack-trace",
                params: { clusterName: _vm.clusterName }
              },
              "data-cy": "stack-trace-link"
            }
          }),
          _vm._v(" "),
          _c("navigation-link", {
            attrs: {
              id: "nav-link-query",
              icon: "icon_lost",
              label: "Query",
              to: {
                name: "workflow/query",
                params: { clusterName: _vm.clusterName }
              },
              "data-cy": "query-link"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "summary",
          baseAPIURL: _vm.baseAPIURL,
          "date-format": _vm.dateFormat,
          "display-workflow-id": _vm.displayWorkflowId,
          domain: _vm.domain,
          input: _vm.summary.input,
          cronSchedule: _vm.summary.cronSchedule,
          isWorkflowRunning: _vm.summary.isWorkflowRunning,
          parentWorkflowRoute: _vm.summary.parentWorkflowRoute,
          result: _vm.summary.result,
          "time-format": _vm.timeFormat,
          timezone: _vm.timezone,
          wfStatus: _vm.summary.wfStatus,
          workflow: _vm.summary.workflow
        },
        on: { onNotification: _vm.onNotification }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "history",
          baseAPIURL: _vm.baseAPIURL,
          events: _vm.historyEvents,
          isWorkflowRunning: _vm.isWorkflowRunning,
          loading: _vm.history.loading,
          timelineEvents: _vm.historyTimelineEvents,
          "workflow-history-event-highlight-list":
            _vm.workflowHistoryEventHighlightList,
          "workflow-history-event-highlight-list-enabled":
            _vm.workflowHistoryEventHighlightListEnabled
        },
        on: {
          onNotification: _vm.onNotification,
          onWorkflowHistoryEventParamToggle:
            _vm.onWorkflowHistoryEventParamToggle
        }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "pending",
          baseAPIURL: _vm.baseAPIURL,
          "time-format": _vm.timeFormat,
          timezone: _vm.timezone
        }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "stacktrace",
          baseAPIURL: _vm.baseAPIURL,
          "date-format": _vm.dateFormat,
          isWorkerRunning: _vm.isWorkerRunning,
          taskListName: _vm.taskList.name,
          "time-format": _vm.timeFormat,
          timezone: _vm.timezone
        },
        on: { onNotification: _vm.onNotification }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "query",
          baseAPIURL: _vm.baseAPIURL,
          isWorkerRunning: _vm.isWorkerRunning,
          taskListName: _vm.taskList.name
        },
        on: { onNotification: _vm.onNotification }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06df7614", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06df7614","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/workflow/component.vue
// module id = 1585
// module chunks = 0